import { TQueryParams } from '@/services/searchApiRequest';
import { EDeliveryOption } from '@/services/types/core/delivery.types';

interface ISearchHeaderDeliveryArgs {
  isDeliveryTab?: boolean;
  deliveryFromStore?: boolean;
  deliveryFromQueryParams: TQueryParams[string];
  deliveryStationaryFromQueryParams: TQueryParams[string];
}

export const getSearchHeaderDelivery = ({
  isDeliveryTab,
  deliveryFromStore,
  deliveryFromQueryParams,
  deliveryStationaryFromQueryParams,
}: ISearchHeaderDeliveryArgs) => ({
  isDeliveryEnabled:
    isDeliveryTab || deliveryFromStore === true || deliveryFromQueryParams === 'true',
  deliveryStationary: isDeliveryTab
    ? EDeliveryOption.STATIONARY
    : (deliveryStationaryFromQueryParams as string),
});
